import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgMiniInfo = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.077 7.611a1.013 1.013 0 00-.077.392 1.006 1.006 0 00.288.712c.09.09.196.16.316.21.12.05.253.075.396.075.14 0 .27-.025.393-.075a.96.96 0 00.53-.527c.051-.121.077-.253.077-.395a1.013 1.013 0 00-.288-.711A1.002 1.002 0 0012 7a.985.985 0 00-.923.611zM12 10a.75.75 0 00-.75.75v4.5a.75.75 0 001.5 0v-4.5A.75.75 0 0012 10z"
      clipRule="evenodd"
    />
  </svg>
));
SvgMiniInfo.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgMiniInfo;
